export default class FluxoBancario {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.data = new Date().yyyymmdd();
        this.bancoId = 0;
        this.planoContaId = 0;
        this.planoContaItemId = 0;
        this.doadorFornecedorId = 0;
        this.descricao = '';
        this.debito = 0;
        this.credito = 0;
        this.transferenciaId = 0;
        //this.recebivelId = 0;
        //this.compromissoId = 0;
        this.transferenciaIdentificada =  false;
        this.numeroCheque = 0;
        this.tipo = 'E';
        this.tipoStr = '';
        this.alvulso = false;
        this.conciliado = false;

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.data = model.data == '' ? new Date() : new Date(model.data).yyyymmdd();
        this.bancoId = model.bancoId;
        this.banco = model.banco;
        this.planoContaId = model.planoContaId;
        this.planoConta = model.planoConta;
        this.planoContaItemId = model.planoContaItemId;
        this.planoContaItem = model.planoContaItem;
        this.doadorFornecedorId = model.doadorFornecedorId;
        this.doadorFornecedor = model.doadorFornecedor;
        this.descricao = model.descricao;

        this.valor = model.valor > 0 ? model.valor : 
            model.debito > 0 ? model.debito : model.credito;

        this.debito = model.tipo == 'S' ? model.valor : 0;
        this.credito = model.tipo == 'E' ? model.valor : 0;
        
        this.transferenciaId = model.transferenciaId;
        this.recebivelId = model.recebivelId;
        this.compromissoId = model.compromissoId;
        this.transferenciaIdentificada = model.transferenciaIdentificada;
        this.numeroCheque = model.numeroCheque;
        this.tipo = model.tipo;
        this.tipoStr = model.tipoStr;
        this.alvulso = model.alvulso;
        this.conciliado = model.conciliado;
    }
}